var counterSlider = {
  selectors: {
    "slider": ".js-counter-slider",
		"slider_output": ".js-counter-slider-output",
  },

  init: function () {
    const self = this;

    jQuery(self.selectors.slider + " input[type='range']").on("input", function () {
			let value = jQuery(this).val();
			let min = parseFloat(jQuery(this).attr("min"));
			let max = parseFloat(jQuery(this).attr("max"));

			// Calculate progress percentage dynamically
			let progress = ((value - min) / (max - min)) * 100;

			if (max == value) {
				value = "> " + value;
			}

			jQuery(this).parent().find(self.selectors.slider_output + " span").text(value);
			jQuery(this).css("--progress", progress + "%");
		});

		//first page load init
		jQuery(self.selectors.slider + " input[type='range']").trigger("input");
  },
}

// Export
export { counterSlider };